<template>
  <div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container" v-if="isLoadDone">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto">
            <div class="row my-3 d-flex align-items-left">
              <FormSearch
                :onChangeSearchParameter="onChangeSearchParameter"
                :isOrder="true"
                :totalDaySelect="30"
                :defaultFromDate="new Date()"
              />
            </div>
            <div class="px-0 mt-5">
              <div class="row d-flex justify-content-center">
                <ul id="general-tab" class="nav nav-tabs">
                  <li class="nav-item nav-first">
                    <a
                      id="nav_item_1"
                      class="nav-link"
                      :class="{ active: type == 1 }"
                      @click="changeTab(1)"
                      >Preparing</a
                    >
                    <div
                      class="count-order"
                      v-if="type == 1 && orders.length > 0"
                    >
                      {{ orders.length }}
                    </div>
                  </li>
                  <li class="nav-item">
                    <a id="nav_item_2" class="nav-link" @click="changeTab(2)"
                      >Ready</a
                    >
                  </li>
                  <li class="nav-item">
                    <a id="nav_item_0" class="nav-link" @click="changeTab(0)"
                      >Pending</a
                    >
                  </li>
                </ul>
              </div>
              <div class="table-responsive p-0 custom-table mt-5">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center font-weight-bolder w-5"></th>
                      <th class="text-center font-weight-bolder">
                        Sales Channel
                      </th>
                      <th class="text-center font-weight-bolder">
                        From
                      </th>
                      <th class="text-center font-weight-bolder">
                        Receipt No.
                      </th>
                      <th class="text-center font-weight-bolder">
                        Order Date Time
                      </th> 
                      <th class="text-center font-weight-bolder">Total</th>
                      <th class="text-center font-weight-bolder w-10">
                        POS Status
                      </th>
                      <th class="text-center font-weight-bolder">
                        Grab Status
                      </th>
                      <th class="text-center font-weight-bolder w-10">
                        Action
                      </th>
                      <th class="text-center font-weight-bolder">Buyer</th>
                      <th class="text-center font-weight-bolder">Pickup Date Time</th>
                      <th class="text-center font-weight-bolder">Delivery Address</th>
                      <th class="text-center font-weight-bolder">Delivery Contact</th>
                    </tr>
                  </thead>
                  <tbody v-if="orders.length">
                    <tr
                      v-for="order in orders"
                      :key="order.transaction_id"
                      :id="'order-' + order.transaction_id"
                    >
                      <td>
                        <i
                          class="material-icons-round opacity-10 mt-1 show-order-info"
                          @click="orderDetail(order)"
                          >add</i
                        >
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.branch_name }}
                      </td>
                      <td class="text-center text-xss cl-22">
                        <img
                          v-if="platformIcon(order)"
                          :src="platformIcon(order)"
                          :alt="platformTitle(order)"
                          :title="platformTitle(order)"
                          style="width: 38px; height: 38px; object-fit: contain;"
                        />
                        <span v-else>{{ order.platform_type_label || '' }}</span>
                      </td>
                      <td class="text-center text-xss font-weight-bold cl-22">
                        {{ order.receipt_no }}
                        <div
                          v-if="order.customer_remark"
                          class="text-danger fw-normal"
                          style="font-size: 11px;"
                        >
                          {{ order.customer_remark }}
                        </div>
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.created_at_format }}
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.payment_amount_format }}
                      </td>
                      <td
                        class="text-center text-xss font-weight-bold"
                        :style="{
                          color: order.pos_status_label_color + ' !important',
                        }"
                      >
                        <div>{{ order.pos_status_label }}</div>
                        <div
                          v-if="
                            order.pos_status_label == 'Failed' &&
                            order.message_error_from_megapos
                          "
                          style="
                            white-space: break-spaces;
                            overflow-wrap: break-word;
                            max-width: 300px;
                          "
                        >
                          {{ order.message_error_from_megapos }}
                        </div>
                      </td>
                      <td class="text-center text-xss font-weight-bold">
                        <span
                          v-if="order.grab_order_state"
                          :style="{ color: order.grab_order_state_color }"
                        >
                          {{ order.grab_order_state }}
                        </span>
                      </td>
                      <td class="text-center text-xss cl-22">
                        <div
                          class="d-flex align-items-center justify-content-center"
                        >
                          <div
                            class="tag-a-custom me-3"
                            v-if="
                              ['Timeout', 'Failed'].includes(
                                order.pos_status_label
                              )
                            "
                            @click="confirmRetryOrder(order)"
                          >
                            Retry
                          </div>
                          <material-button
                            v-if="type == ORDER_STATUS.PREPARING && (order.pos_status_label == 'Inserted' || order.update_order_status_without_pos)"
                            class="btn-confirm-order"
                            @click="moveOrderToReady(order)"
                          >
                            <i class="material-icons-round opacity-10 mt-1"
                              >local_mall</i
                            >
                          </material-button>
                          <button
                            v-if="canRefundOrder(order)"
                            type="button"
                            class="btn-refund-action ms-2"
                            @click="openRefundModal(order)"
                            :title="order.allinpay_card ? 'Void card payment' : 'Refund'"
                          >
                            <i class="material-icons">undo</i>
                            <!-- Allinpay card orders are voided, never refunded here -->
                            <span>{{ order.allinpay_card ? 'Void' : 'Refund' }}</span>
                          </button>
                          <span
                            v-if="needsOatsRefund(order)"
                            class="text-xxs text-secondary ms-2"
                            title="Allinpay only voids a card payment on the day it was taken, before the terminal is settled. Refund it in Allinpay OATS or with Allinpay's manual refund form: part of it is allowed, within 30 to 180 days depending on the card, and the MID needs enough balance."
                          >Refund via Allinpay OATS</span>
                          <span
                            v-if="!order.refund_status && airwallexRefundNote(order)"
                            class="text-xxs ms-2"
                            :class="airwallexRefundNote(order).error ? 'text-danger' : 'text-secondary'"
                          >{{ airwallexRefundNote(order).text }}</span>
                        </div>
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.pickup_contact_name ?? order.delivery_contact_buyer_name ?? order.member_name ?? '' }} <br />
                        {{ order.pickup_contact_phone ?? order.delivery_contact_buyer_phone ?? order.phone_number ?? '' }}
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.pickup_date_time_format ?? '' }}
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.delivery_contact_address_line_1 ?? '' }}  <br />
                        {{ order.delivery_contact_address_line_2 ?? '' }}  <br />
                        {{ order.delivery_contact_postal_code ?? '' }}
                      </td>
                      <td class="text-center text-xss cl-22">
                        {{ order.delivery_contact_recipient_name ?? '' }} <br />
                        {{ order.delivery_contact_recipient_phone ?? '' }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else class="no-data">
                    <tr>
                      <td colspan="12" class="text-center">Empty, no order.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm :message="messageConfirm" :process-yes="processYes" />
      <RefundModal
        ref="refundModal"
        :merchant-code="merchantCode"
        @refunded="onRefunded"
        @error="onRefundError"
      />
    </div>
  </div>
</template>

<script>
import SettingStoreService from "../../../services/settingStore.service";
import ModalConfirm from "@/components/ModalConfirm.vue";
import $ from "jquery";
import FormSearch from "./FormSearch.vue";
import moment from "moment";
import BoardRealtime from "../../../services/board-realtime";
import MaterialButton from "@/components/MaterialButton.vue";
import { ORDER_STATUS } from "../mock_data";
import posIcon from "@/assets/img/platform_type_icons/pos-icon.gif";
import qrIcon from "@/assets/img/platform_type_icons/qr-icon.png";
import kioskIcon from "@/assets/img/platform_type_icons/kiosk-icon.webp";
import grabIcon from "@/assets/img/platform_type_icons/grab-icon.png";
import lalamoveIcon from "@/assets/img/platform_type_icons/delivery-bike-icon.png";
import RefundModal from "@/views/members/components/RefundModal.vue";
import { canRefundAirwallex, airwallexRefundNote } from "@/views/members/components/airwallexRefund";

// M1006: delivery_method of an order that goes out by a Lalamove driver (3 = own delivery).
const LALAMOVE_DELIVERY_METHODS = [1, 2];


// With a live socket the timer is no longer how this screen learns about orders
// — but it can never stop. This endpoint runs behind stock.passcode, and the
// request is what slides the passcode's hour forward.
const POLL_INTERVAL_MS = 15000;
const HEARTBEAT_INTERVAL_MS = 300000;

// One POS push moves several orders; each would otherwise cost a full re-read.
const COALESCE_MS = 400;

// connection.ready fires on every reconnect, so a websocket-server restart would
// have every screen in every outlet re-read at the same instant.
// Twenty seconds, not five: an Apache or websocket restart drops every board in
// every outlet at once, and their catch-up reads land on the same 80 php-fpm
// workers as the customer screens reconnecting beside them. Only that catch-up
// read waits; a board.updated after the reconnect is read at once.
const RESYNC_JITTER_MS = 20000;

export default {
  name: "OrderManagement",
  components: {
    ModalConfirm,
    FormSearch,
    MaterialButton,
    RefundModal,
  },
  props: {
    showLoader: {
      type: Function,
      required: true,
    },
    hideLoader: {
      type: Function,
      required: true,
    },
    showNotification: {
      type: Function,
      required: true,
    },
    getPhysicalBranch: {
      type: Function,
      default: () => {},
    },
    // The page level passcode gate, owned by StockByPhysicalBranch. This tab is
    // only rendered once the gate is open, so it only needs them for its writes.
    requirePasscode: {
      type: Function,
      required: true,
    },
    handlePasscodeRequired: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoadDone: false,
      physicalBranchId: 0,
      merchantId: 0,
      orders: [],
      expandedOrderIds: [],
      platformTypeIcons: {
        1: posIcon,
        2: qrIcon,
        3: kioskIcon,
        4: grabIcon,
      },
      interval: null,
      messageConfirm: "",
      orderSelect: null,
      form: {
        from_date: new Date(),
        to_date: new Date(),
        status: 0,
        search_keyword: "",
      },
      type: 1,
      ORDER_STATUS,
      merchantCode: localStorage.getItem("MERCHANT_CODE") || "",
      pollIntervalMs: null,
      realtime: null,
      realtimeConnected: false,
      refreshTimer: null,
      // When the armed refreshTimer fires, so a sooner request can replace it.
      refreshDueAt: 0,
      // A signal landed while a read was in flight and still owes us one more.
      refreshPending: false,
      // getOrderByBranch has no guard of its own, and this path is no longer
      // reached only by a 15s timer: a socket signal can arrive at any moment.
      // Two overlapping reads can finish out of order and render stale rows —
      // and this screen re-opens expanded rows after each render.
      isRefreshingList: false,
      // Bumped per list request. The guard above only covers the poll path; a
      // tab switch or filter change reads straight away, so the answer that
      // lands last is not necessarily the one asked for last.
      listSeq: 0,
      // The latest request that showed the loader, and so owns hiding it.
      loaderSeq: 0,
      // Random first delay before interval starts (see armPollTimer).
      pollPhaseTimer: null,
      isDestroyed: false,
    };
  },
  created() {
    this.physicalBranchId = this.$route.params.branch_id ?? 0;
    this.merchantId = this.$route.params.merchant_id ?? 1;
  },
  mounted() {
    this.getOrderByBranch(true);
    this.armPollTimer();
    this.startRealtime();
  },
  unmounted() {
    this.isDestroyed = true;
    clearTimeout(this.pollPhaseTimer);
    this.pollPhaseTimer = null;
    clearInterval(this.interval);
    this.interval = null;
    clearTimeout(this.refreshTimer);
    this.refreshTimer = null;

    if (this.realtime) {
      this.realtime.stop();
      this.realtime = null;
    }
  },
  methods: {
    // M1006: a delivery that goes out by a Lalamove driver - picked in the Accept
    // popup (Motorcycle / Car), or booked on payment for a POS-linked store.
    isLalamoveOrder(order) {
      return LALAMOVE_DELIVERY_METHODS.includes(Number(order.delivery_method)) || Boolean(order.lalamove_status);
    },
    platformIcon(order) {
      return this.isLalamoveOrder(order) ? lalamoveIcon : this.platformTypeIcons[order.platform_type];
    },
    platformTitle(order) {
      return this.isLalamoveOrder(order) ? "Lalamove Delivery" : order.platform_type_label || "";
    },
    // trailing: false is for the timer tick — it names no particular change, so
    // a read already running is exactly what it would have asked for.
    async onPollTick({ trailing = true } = {}) {
      if (!this.isLoadDone) return;

      if (this.isRefreshingList) {
        if (trailing) this.refreshPending = true;
        return;
      }

      this.isRefreshingList = true;
      this.refreshPending = false;

      try {
        // Auto refresh: no loading overlay, and any rows the user expanded are
        // re-opened once the new list has rendered (see restoreExpandedOrders).
        await this.getOrderByBranch(false, true);
      } finally {
        this.isRefreshingList = false;
      }

      // A signal landed mid-read. The read above cannot be trusted to include
      // it, so spend exactly one more.
      if (this.refreshPending && !this.isDestroyed) {
        this.refreshPending = false;
        this.requestListRefresh();
      }
    },

    boardTokenScope() {
      return this.physicalBranchId
        ? { merchant_id: this.merchantId, physical_branch_id: this.physicalBranchId }
        : null;
    },

    /**
     * Arm the fallback timer at the rate the socket's state calls for.
     *
     * Never null, at any rate. This endpoint runs behind stock.passcode, and the
     * request is what slides the passcode's hour forward — a screen that stopped
     * calling it would lock while someone was using it.
     */
    armPollTimer() {
      if (this.isDestroyed) return;

      const wanted = this.realtimeConnected
        ? HEARTBEAT_INTERVAL_MS
        : POLL_INTERVAL_MS;

      if ((this.interval || this.pollPhaseTimer) && this.pollIntervalMs === wanted) {
        return;
      }

      clearTimeout(this.pollPhaseTimer);
      clearInterval(this.interval);
      this.interval = null;
      this.pollIntervalMs = wanted;

      // A socket restart re-arms every screen in the same second. Starting the
      // interval at a random point in its period keeps them from polling in
      // lockstep from then on.
      this.pollPhaseTimer = setTimeout(() => {
        this.pollPhaseTimer = null;
        this.interval = setInterval(
          () => this.onPollTick({ trailing: false }),
          wanted
        );
      }, Math.random() * wanted);
    },

    /**
     * Coalesce every reason to re-read into one request.
     *
     * One POS push moves several orders at once, so a burst is the normal case.
     */
    requestListRefresh(delayMs = COALESCE_MS) {
      if (this.isDestroyed) return;

      // An armed timer covers this request unless it fires later than asked —
      // a real change must not wait behind a reconnect's random resync delay.
      if (this.refreshTimer) {
        if (Date.now() + delayMs >= this.refreshDueAt) return;
        clearTimeout(this.refreshTimer);
      }

      this.refreshDueAt = Date.now() + delayMs;
      this.refreshTimer = setTimeout(() => {
        this.refreshTimer = null;
        this.onPollTick();
      }, delayMs);
    },

    // Realtime is best effort. If the token call fails or the socket never
    // connects, the screen keeps polling at the old rate and nothing above this
    // needs to know.
    async startRealtime() {
      if (this.isDestroyed || this.realtime) return;

      const scope = this.boardTokenScope();

      if (!scope) return;

      this.realtime = new BoardRealtime({
        fetchToken: async () => {
          const response = await SettingStoreService.getWsTokenForBoard(scope);
          const result = response.data.result;

          return result && result.isSuccess ? response.data.data : null;
        },
        onSignal: (signal) => {
          this.requestListRefresh(
            signal && signal.resync ? Math.random() * RESYNC_JITTER_MS : COALESCE_MS
          );
        },
        onConnectionChange: (connected) => {
          this.realtimeConnected = connected;
          this.armPollTimer();
        },
      });

      await this.realtime.start();
    },


    changeTab(type) {
      this.collapseAllOrderDetails();
      this.searchKeyword = "";
      this.orders = {};
      this.type = type;
      $("#general-tab .nav-link").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      this.getOrderByBranch();
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    getOrderByBranch(isFirstLoad = false, isSilent = false) {
      if (this.physicalBranchId) {
        const seq = ++this.listSeq;
        if (!isSilent) {
          this.loaderSeq = seq;
          this.showLoader();
        }
        // Silent reads never hide the loader, so a dropped answer must still
        // clear it unless a newer loud read has taken it over.
        const ownsLoader = () => !isSilent && seq === this.loaderSeq;
        var dataForm = {
          merchant_id: this.merchantId,
          physical_branch_id: this.physicalBranchId,
          search_keyword: this.form.search_keyword,
          from_date: this.dateFormat(this.form.from_date),
          to_date: this.dateFormat(this.form.to_date),
          type: this.type,
        };

        // Returned so the caller can tell when the read is over. Existing
        // callers ignore it, exactly as before.
        return SettingStoreService.getOrderByPhysicBranch(dataForm).then(
          (response) => {
            // A newer read is out (tab switch, filter, signal): its rows win
            // whichever answer lands first.
            if (seq !== this.listSeq) {
              if (ownsLoader()) this.hideLoader();
              return;
            }

            if (response.data.result.isSuccess) {
              this.orders = response.data.data.orders;

              if (response.data.data.physical_branch) {
                this.getPhysicalBranch(response.data.data.physical_branch);
              }

              if (isFirstLoad) {
                this.isLoadDone = true;
              }

              this.restoreExpandedOrders();
            } else if (!this.handlePasscodeRequired(response)) {
              // No retry closure on purpose: locking unmounts this tab, and the
              // fresh one that mounts after unlocking fetches on its own.
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            if (ownsLoader()) {
              this.hideLoader();
            }
          },
          (error) => {
            if (seq !== this.listSeq) {
              if (ownsLoader()) this.hideLoader();
              return;
            }

            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            if (ownsLoader()) {
              this.hideLoader();
            }
          }
        );
      }

      return Promise.resolve();
    },

    onChangeSearchParameter(value, fieldName, reLoad = true) {
      this.form[fieldName] = value !== null ? value : "";

      if (reLoad) {
        this.getOrderByBranch();
      }
    },

    orderDetail(order) {
      var transactionId = order.transaction_id;

      if ($(".order-detail.order-" + transactionId).length) {
        this.forgetExpandedOrder(transactionId);
        this.collapseOrderDetail(transactionId);
        return;
      }

      if (!this.expandedOrderIds.includes(transactionId)) {
        this.expandedOrderIds.push(transactionId);
      }

      this.showLoader();
      this.renderOrderDetail(transactionId).then(
        (response) => {
          if (!response.data.result.isSuccess) {
            this.forgetExpandedOrder(transactionId);
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.forgetExpandedOrder(transactionId);
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    // Fetches the detail HTML for one order and injects it right under its row.
    // The row is looked up by transaction_id, so a reordered list or a newly
    // arrived order can never attach a detail row to the wrong order.
    renderOrderDetail(transactionId) {
      var dataForm = {
        merchant_id: this.merchantId,
        physical_branch_id: this.physicalBranchId,
        transaction_id: transactionId,
      };

      return SettingStoreService.orderDetail(dataForm).then((response) => {
        var row = $("#order-" + transactionId);

        // The user may have collapsed the row, or switched tab, while the
        // request was in flight - do not re-open it in that case.
        if (
          response.data.result.isSuccess &&
          row.length &&
          this.expandedOrderIds.includes(transactionId)
        ) {
          $(".order-detail.order-" + transactionId).remove();
          row.find("i.show-order-info").html("remove");
          row.after(response.data.data);
        }

        return response;
      });
    },

    // Re-opens the rows the user had expanded, after the list has been
    // re-rendered by a refresh (auto refresh, retry, move to ready, search...).
    restoreExpandedOrders() {
      if (!this.expandedOrderIds.length) {
        return;
      }

      // Drop ids that are no longer listed - e.g. the order moved to another
      // tab - and clear the detail rows they would otherwise leave orphaned.
      var visibleIds = (this.orders || []).map((order) => order.transaction_id);
      this.expandedOrderIds
        .filter((id) => !visibleIds.includes(id))
        .forEach((id) => this.collapseOrderDetail(id));
      this.expandedOrderIds = this.expandedOrderIds.filter((id) =>
        visibleIds.includes(id)
      );

      this.$nextTick(() => {
        this.expandedOrderIds.forEach((transactionId) => {
          // Re-attach the detail already on screen to its row first: the patch
          // may have moved rows around, and the fresh copy is still in flight.
          var row = $("#order-" + transactionId);
          var detail = $(".order-detail.order-" + transactionId);
          if (row.length && detail.length) {
            row.find("i.show-order-info").html("remove");
            row.after(detail);
          }

          this.renderOrderDetail(transactionId).catch(() => {});
        });
      });
    },

    forgetExpandedOrder(transactionId) {
      this.expandedOrderIds = this.expandedOrderIds.filter(
        (id) => id !== transactionId
      );
    },

    collapseOrderDetail(transactionId) {
      $(".order-detail.order-" + transactionId).remove();
      $("#order-" + transactionId + " i.show-order-info").html("add");
    },

    collapseAllOrderDetails() {
      this.expandedOrderIds = [];
      $(".order-detail").remove();
      $(".show-order-info").html("add");
    },

    processYes() {
      if (this.orderSelect) {
        if (this.orderSelect.pos_status_label == 'Inserted' || this.orderSelect.update_order_status_without_pos) {
          this.handleMoveOrder();
        } else {
          this.retryOrder();
        }
      }
    },

    confirmRetryOrder(order) {
      this.messageConfirm = "Are you sure you want to retry this order?";
      $(".btn-confirm-modal").click();
      this.orderSelect = order;
    },

    retryOrder() {
      $(".btn-close-modal").click();

      const order = this.orderSelect;

      this.requirePasscode(() => this.sendRetryOrder(order));
    },

    sendRetryOrder(order) {
      this.showLoader();

      var dataForm = {
        merchant_id: this.merchantId,
        physical_branch_id: this.physicalBranchId,
        transaction_id: order.transaction_id,
      };

      SettingStoreService.retryOrder(dataForm).then(
        async (response) => {
          if (response.data.result.isSuccess) {
            this.showNotification("Order retry successfully", "success");
            this.getOrderByBranch();
          } else if (
            !this.handlePasscodeRequired(response, () =>
              this.sendRetryOrder(order)
            )
          ) {
            this.showNotification(response.data.result.message, "danger");
          }
          this.hideLoader();
        },
        (error) => {
          this.showNotification(error, "danger");
          this.hideLoader();
        }
      );
    },

    /**
     * Refund eligibility: the order must have been paid via Airwallex
     * (airwallex_order_id present), or by card on a kiosk's Allinpay terminal
     * and still voidable (allinpay_voidable: today, before the terminal is
     * settled), AND the remaining refundable balance must be > 0. BE
     * re-validates everything — this is just the UI gate.
     */
    canRefundOrder(order) {
      if (!order || !order.transaction_id) return false;
      if (!order.airwallex_order_id && !order.allinpay_card) return false;
      // Airwallex: the BE works out what is still refundable (RefundSummary);
      // an API without those fields yet keeps the check below.
      if (!order.allinpay_card && order.airwallex_refundable !== undefined) return canRefundAirwallex(order);
      // Allinpay: a void still being confirmed is checked from the modal.
      if (order.allinpay_refund_pending) return true;
      if (order.allinpay_card && !order.allinpay_voidable) return false;
      const paid = Number(order.payment_amount || 0);
      const refunded = Number(order.total_refund_amount || 0);
      return paid > 0 && refunded < paid;
    },
    // Allinpay card payment past its void window, not given back yet.
    needsOatsRefund(order) {
      if (!order || !order.allinpay_card || order.allinpay_voidable || order.allinpay_refund_pending) return false;
      return Number(order.total_refund_amount || 0) < Number(order.payment_amount || 0);
    },
    airwallexRefundNote,
    openRefundModal(order) {
      this.$refs.refundModal.open(order);
    },
    onRefunded(event) {
      this.showNotification(event?.message || "Refund successful", "success");
      // Reload list so the just-refunded order shows the new
      // total_refund_amount (and the Refund option hides when fully
      // refunded). Also collapse any open detail rows so the table
      // doesn't render stale order details.
      this.collapseAllOrderDetails();
      this.getOrderByBranch();
    },
    onRefundError(message) {
      this.showNotification(message || "Refund failed", "danger");
    },

    moveOrderToReady(order) {
      this.orderSelect = order;
      this.messageConfirm =
        "Confirm to change the status for order " +
        order.receipt_no +
        " to ready for collection?";
      $(".btn-confirm-modal").click();
    },

    handleMoveOrder() {
      $(".btn-close-modal").click();

      if (this.orderSelect && this.orderSelect.transaction_id) {
        const order = this.orderSelect;

        this.requirePasscode(() => this.sendMoveOrder(order));
      }
    },

    sendMoveOrder(order) {
      this.showLoader();

      var dataForm = {
        merchant_id: this.merchantId,
        physical_branch_id: this.physicalBranchId,
        transaction_id: order.transaction_id,
      };

      SettingStoreService.moveOrder(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.orderSelect = {};
            this.showNotification("Move successfully", "success");
            this.getOrderByBranch();
          } else if (
            !this.handlePasscodeRequired(response, () =>
              this.sendMoveOrder(order)
            )
          ) {
            this.showNotification(response.data.result.message, "danger");
          }
          this.hideLoader();
        },
        (error) => {
          this.showNotification(error, "danger");
          this.hideLoader();
        }
      );
    },

  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: auto;
}

table th,
table td {
  padding: 0.35rem 0.4rem !important;
}

.page-header .container {
  color: #222 !important;
}

.cl-22 {
  color: #222 !important;
}

.show-order-info {
  font-size: 28px !important;
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

#general-tab .nav-item {
  width: 25%;
  text-align: center;
}

.nav-first {
  position: relative;
}

.nav-link {
  font-weight: bold;
}

.nav-first .count-order {
  position: absolute;
  top: 5px;
  right: 5px;
  border: 1px solid red;
  background: red;
  color: #ffffff;
  border-radius: 5px;
  padding: 0px 7px;
}

.btn-confirm-order {
  min-width: 50px !important;
  padding: 5px 10px !important;
  color: #28a745 !important;
  border-color: #28a745 !important;
}

.btn-confirm-order:hover {
  background: #28a745 !important;
  color: #ffffff !important;
}

.btn-refund-action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px solid #4f46e5;
  background: #ffffff;
  color: #4f46e5;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.btn-refund-action:hover {
  background: #4f46e5;
  color: #ffffff;
}

.btn-refund-action .material-icons {
  font-size: 14px;
}

@media (max-width: 500px) {
  #general-tab .nav-item {
    width: calc(100% / 3) !important;
  }
}
</style>
